import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { APIService } from "./APIService";
import { CreateSupplierDTO } from "../models/Supplier/CreateSupplierDTO";
import { SearchBySupplierNameDTO } from "../models/Supplier/SearchBySupplierNameDTO"; 
import { SupplierDTO } from "../models/Supplier/SupplierDTO";
import { UpdateSupplierDTO } from "../models/Supplier/UpdateSupplierDTO";
import { Parameter } from "../models/Parameter";
import { GetFileDTO } from "../models/File/GetFileDTO";

// Interface for file upload
interface FileDTO {
    file: File;
}

export class SupplierService {

    async SearchByName(
        searchParams: SearchBySupplierNameDTO,
    ): Promise<MessagingHelper<SupplierDTO[] | null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Supplier/SearchByName`,
                {
                    ...searchParams,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },  
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor ao obter a informação dos fornecedores",
                null
            );
        }
    }

    async GetById(id: number): Promise<MessagingHelper<SupplierDTO | null>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/Supplier/${id}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao obter a informação do fornecedor",
                null
            );
        }
    }

    async DownloadSuppilers(): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/Supplier/DownloadSuppilers`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao descarregar a informação dos fornecedores",
                null
            );
        }
    }

    async ImportSuppliers(fileDto: FileDTO): Promise<MessagingHelper<null>> {
        try {
            const formData = new FormData();
            formData.append("File", fileDto.file);
            
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Supplier/ImportSuppliers`,
                formData,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao importar fornecedores",
                null
            );
        }
    }

    async GetAll(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ): Promise<PaginatedList<SupplierDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Supplier/GetAll`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<SupplierDTO>(
                false,
                "Erro ao obter a informação dos fornecedores",
                "",
                [],
                0,
            );
        }
    }

    async Create(supplier: CreateSupplierDTO): Promise<MessagingHelper<SupplierDTO | null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Supplier/Create`,
                {
                    ...supplier
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao criar fornecedor",
                null
            );
        }
    }

    async Update(supplier: UpdateSupplierDTO): Promise<MessagingHelper<SupplierDTO | null>> {
        try {
            var response = await APIService.Axios().put(
                `${APIService.GetURL()}/Supplier/Update`,
                {
                    ...supplier
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao atualizar fornecedor",
                null
            );
        }
    }

    async Delete(id: number): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().delete(
                `${APIService.GetURL()}/Supplier/Delete/${id}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao eliminar fornecedor",
                null
            );
        }
    }
}
